module.exports = __webpack_public_path__ + "img/roll_face_right.5d611423.svg";